import { CardMedia, Box } from '@mui/material';
import { cssAspectRatioFromDomainImage, isRoundCrop } from '../../utils/photoAspectRatio';

/**
 * Display frame for a cropped domain photo. Width fills the column;
 * height follows the stored aspect (square, 16:9, 4:3, 3:4, free crop).
 * Never set a fixed height (e.g. 263) — that stretches the crop.
 */
const EntityPhotoFrame = ({
  image,
  src,
  alt,
  className = '',
  showBlur = false,
  children,
}) => {
  const aspectRatio = cssAspectRatioFromDomainImage(image);
  const round = isRoundCrop(image);
  const radius = round ? '50%' : undefined;

  return (
    <Box
      className={className}
      data-aspect-ratio={aspectRatio}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        aspectRatio,
        borderRadius: radius,
      }}
    >
      {showBlur && (
        <CardMedia
          component="img"
          image={src}
          alt=""
          loading="lazy"
          decoding="async"
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(10px)',
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />
      )}
      <CardMedia
        component="img"
        image={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: 1,
          borderRadius: radius,
        }}
      />
      {children}
    </Box>
  );
};

export default EntityPhotoFrame;
